import { render, staticRenderFns } from "./smt_eq_notice.vue?vue&type=template&id=be84169e&scoped=true"
import script from "./smt_eq_notice.vue?vue&type=script&lang=js"
export * from "./smt_eq_notice.vue?vue&type=script&lang=js"
import style0 from "./smt_eq_notice.vue?vue&type=style&index=0&id=be84169e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be84169e",
  null
  
)

export default component.exports